export {};

declare global {
    interface Array<T> {

        /**
         * Returns the first element of an array.
         */
        first(): T | undefined;

        /**
         * Returns the last element of an array.
         */
        last(): T | undefined;

        /**
         * Returns a page of an array base on the given parameters.
         * The result is a copy of the array
         * @param currentPage The desired page
         * @param pageSize The pagination size
         */
        paginate(currentPage: number, pageSize: number): T[] | undefined;
    }
}

/**
 * Implementation of first()
 */
if (!Array.prototype.first) {
    Array.prototype.first = function() {
        if (!this.length) {
            return undefined;
        }
        return this[0];
    };
}

/**
 * Implementation of last()
 */
if (!Array.prototype.last) {
    Array.prototype.last = function() {
        if (!this.length) {
            return undefined;
        }
        return this[this.length - 1];
    };
}

/**
 * Implementation of paginate()
 */
if (!Array.prototype.paginate) {
    Array.prototype.paginate = function(currentPage: number, pageSize: number) {
        if (!this.length) {
            return undefined;
        }
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return this.slice(startIndex, endIndex);
    };
}
